export const getIsCampana = (org = 'default') => {
  const ORG_NAME: { [value: string]: string } = {
    olx: 'olx',
    olx_pay: 'pay',
    default: 'default',
  };

  const channelClosedForm = process.env.NEXT_PUBLIC_IS_CAMPANA_ENABLED ?? '';
  const orgName = ORG_NAME[org];

  return channelClosedForm.includes(orgName);
};
